export default __webpack_public_path__ + "static/IN-9008v5905_resTestBig2-5f7cd7072572819490ab699a5a91dc7e.webp";